import { faBinoculars } from '@fortawesome/pro-solid-svg-icons';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CustomButton } from 'commons/Button/CustomButton';
import CustomIcon from 'commons/Icon/CustomIcon';
import LocalizedText, { localize } from 'commons/LocalizedText/LocalizedText';
import useFetch from 'hook/UseFetch';
import useRealParams from 'hook/UseRealParams';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UserService } from 'services/UserService';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      marginBottom: theme.spacing(1)
    }
  },
  margin: {
    margin: theme.spacing(1)
  },
  impersonationPicker: {
    maxWidth: 430,
    margin: theme.spacing(1),
    flexGrow: 1
  }
}));

export const ManageImpersonation = () => {
  const classes = useStyles();
  const history = useHistory();
  const { laboratory: laboratoryId } = useRealParams();
  const {response: users, isLoading} = useFetch(() => UserService.getLaboUsersForImpersonation(laboratoryId), []);
  const [impersonatingUser, setImpersonatingUser] = useState(null);

  return (
    <>
      <LocalizedText className={classes.sectionTitle} component="h5" variant="h5">
        impersonationManagement
      </LocalizedText>
      <Grid
        alignItems="center"
        container
        direction="row"
      >
        <Autocomplete
          className={classes.impersonationPicker}
          getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${(option.personNumber)})`}
          id="user-impersonation-selection"
          loading={isLoading}
          loadingText={localize('loadingText')}
          noOptionsText={localize('noOptionsText')}
          onChange={async (e, value) => {
            if (value) {
              setImpersonatingUser(value);
            }
          }}
          options={users}
          renderInput={(params) => (
            <TextField
              {...params}
              label={localize('chooseUserToImpersonate')}
              variant="outlined"
            />
          )}
          value={impersonatingUser}
        />
        <CustomButton
          className={classes.margin}
          onClick={async () => {
            if (impersonatingUser) {
              await UserService.setImpersonation(impersonatingUser.accountRecid);
              history.replace(GENERATE_ROUTE(`${ROUTES.CHOICE}`));
              window.location.reload();
            }
          }}
        >
          <CustomIcon icon={faBinoculars} />
          <span>&nbsp;</span>{localize('impersonate')}
        </CustomButton>
      </Grid>
    </>
  );
};